import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import Comments from "../../components/Comments/Comments";
import * as actions from "../../store/actions";

const NewComments = () => {

    const commentData = useSelector(state => state.comment.comments)
    const loading = useSelector(state => state.comment.commentLoading)

    const dispatch = useDispatch()

    useEffect(() => {
        const commentUrl = "/comments.json"
        dispatch(actions.postComment(commentUrl))
        document.title = "New Comments | Hacker News clone"
    }, [dispatch])

    return (
        <div className="NewComments">
            {loading ? "Loading..." : null}
            <Comments commentData={commentData}/>
        </div>
    )
}

export default NewComments;